// Charge la base commune
import './common.js'

// charge bootstrap Scrollspy
import 'bootstrap/js/dist/scrollspy'

// Styles custom
import './scss/pages/models.all.scss'

// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// OwlCarousel
async function getOwlCarousel () {
  import(/* webpackChunkName: "owl-carousel" */ './js/components/owl-carousel.js').then(() => {
    r()
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination", webpackPrefetch: true */ './js/components/pajination.js').then(() => {
    r()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').on('click', function () {
      $('html,body').animate({ scrollTop: $('#all-models').offset().top - 100 }, 300)
      r()
    })
  })
}

// Quick House Models Search Form
async function getQhmFormIn ($f) {
  import(/* webpackChunkName: "quick-house-models-search-form", webpackPrefetch: true */ './js/components/quick-house-models-search-form.js').then(() => {
    $f.load(false)
  })
}

// Contact Form
async function getContactForm ($f) {
  import(/* webpackChunkName: "contact-form" */ './js/components/contact-form.js').then(() => {
    $f.load(false)
    r()
  })
}

// Agency autocomplete
async function getAgencyAutocomplete ($f) {
  import(/* webpackChunkName: "quick-agency-search-form" */ './js/components/quick-agency-search-form.js').then(module => {
    const form = module.qasForm
    form.init($f)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des carousel
  const $d = $('.owl-carousel.c')
  if ($d.length) {
    $d.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $p = $('.pajinate')
  if ($p.length) {
    $p.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de recherche des modèles
  const $c = $('.qhmForm.in')
  if ($c.length) {
    $c.waypoint(function () {
      $c.load()
      getQhmFormIn($c)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      $f.load()
      getContactForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="qasForm"] input[name="search"]').on('click', function () {
    $(this).blur().off('click').attr('disabled', '')
    getAgencyAutocomplete($(this).parents('form'))
  })

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    r()
  })

  // formulaire de tri ou du nombre d'éléments affichables
  $('form[name="model-display-form"] select').on('change', function () {
    $(this).parents('form').submit()
  })

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({
      scrollTop: ($(t).offset().top - $('#header').height() - 50)
    }, 300)
  }

  const $mn = $('#main-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '1020') } else { $mn.parents('.sticky-top').css('z-index', '999') }
  })
})
